import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { generateGuid } from 'utils/guid';

export const updateLoadingVersion: GraphCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.loadingVersion = generateGuid();
  });
};
